import React from 'react';
import PropTypes from 'prop-types';
import Media from '../media/media';
import Video from '../video/video';
import {Link} from 'react-router-dom';

import {observer} from 'mobx-react';

@observer
export default class AccordionItemBody extends React.Component {

  static propTypes = {
    itemArray: PropTypes.array,
    isExpanded: PropTypes.bool,
    sectionId: PropTypes.number.isRequired,
    isInEditMode: PropTypes.bool,
    sectionType: PropTypes.string
  }

  static defaultProps = {
    itemArray: [],
    isExpanded: false
  }

  constructor(props) {
    super(props);
    this.itemType = this.props.sectionType;
  }

  renderMediaListItems = () => {
    const sortedItems = this.props.itemArray.slice().sort(function(a,b){
      if(a.title.toUpperCase() < b.title.toUpperCase()) { return -1; }
      if(a.title.toUpperCase() > b.title.toUpperCase()) { return 1; }
      return 0;
    });
    return sortedItems.map((item, idx) => {
      if(item.type === 'VIDEO') {
        return this.renderVideoItem(item, idx);
      } else {
        return this.renderMediaItem(item);
      }
    });
  }

  renderMediaItem = (item) => {
    return (
      <Media
        key={item.id}
        id={item.id}
        title={item.title}
        description={item.description}
        fileName={item.fileName}
        href={item.href}
        image={item.image}
        imageAltText={item.imageAltText}
        sectionId={this.props.sectionId}
        keywords={item.keywords}
        isInEditMode={this.props.isInEditMode} />
    )
  }

  renderVideoItem = (item) => {
    return (
      <Video
        key={item.id}
        id={item.id}
        title={item.title}
        description={item.description}
        fileName={item.fileName}
        href={item.href}
        image={item.image}
        imageAltText={item.imageAltText}
        lengthInSeconds={item.lengthInSeconds}
        caption={item.caption}
        sectionId={this.props.sectionId}
        isInEditMode={this.props.isInEditMode}
        keywords={item.keywords}
        />
    )
  }

  renderAddMediaItemButton = () => {
    let typeString = this.itemType.toLowerCase();
    if(typeString === 'link') typeString = 'external link';
    return (<Link to={`/content/add/${this.props.sectionId}`} className="add-media-item btn">
      <i className="icon-upload-server" aria-hidden="true" />
      {`Add new ${typeString}`}
    </Link>)
  }

  render() {
    const templateType = (this.itemType==='VIDEO') ? 'video-item-template' : 'media-item-template';
    if (this.props.itemArray[0] && this.props.itemArray[0].type === 'DIRECT_LINK') {
      return null;
    } else {
      return (<div className="accordion__panel" style={{display: `${this.props.isExpanded ? 'block' : 'none'}`}}>
        <div className={`col-12 ${templateType}`}>
          {this.renderMediaListItems()}
          {this.props.isInEditMode && this.renderAddMediaItemButton()}
        </div>
      </div>)
    }
  }
}
